import * as mutationTypes from './types/mutations';

export default {
  [mutationTypes.SET_MOBILE]: (state, value) => {
    state.mobile = value
  },
  [mutationTypes.SET_MENU]: (state, value) => {
    state.mobileMenu = value
  },
};